import { type MutationError, trpc } from '@/shared/api';

interface UseSetExhibitionVisibilityOptions {
  readonly onSuccess?: () => void;
}

/** 공개·숨김을 바꾼다. 공개는 대표 이미지와 공개 상품 1개 이상을 서버가 다시 확인한다. */
export const useSetExhibitionVisibility = ({
  onSuccess,
}: UseSetExhibitionVisibilityOptions = {}) => {
  const mutation = trpc.productManagement.exhibitions.setVisibility.useMutation({ onSuccess });
  const error: MutationError | null = mutation.error;

  return {
    setVisibility: (id: string, isVisible: boolean) => mutation.mutate({ id, isVisible }),
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 목록의 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
